export default __webpack_public_path__ + "static/media/1-06.c20ed4ef.png";